import { render, staticRenderFns } from "./404.vue?vue&type=template&id=0d43f6b7&scoped=true&lang=pug&"
import script from "./404.vue?vue&type=script&lang=js&"
export * from "./404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d43f6b7",
  null
  
)

export default component.exports